import { AccountObject } from "./account-object.model";
import { Category } from "./category.model";
import { AccountObjectQueryFactory } from "../account-object/account-object.query-factory";
import { BaseObjectFilters } from "../../store/bootstrap";

export class CategoryQueryFactory<T extends Category, F extends BaseObjectFilters> extends AccountObjectQueryFactory<T, F> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.query-factory.ts